let Backbone = require("backbone");
let _ = require("underscore");

let main = function (Backbone, _) {
    return Backbone.Model.extend({

    });
};

let exportedValue = main(Backbone, _);
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/model/settings/BookingResourceModel.js